import { NgModule, Directive } from '@angular/core';
import { CommonModule } from '@angular/common';

// Antd module
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzAnchorModule } from 'ng-zorro-antd/anchor';
import { NzPipesModule } from 'ng-zorro-antd/pipes';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        NzButtonModule,
        NzIconModule,
        NzTableModule,
        NzInputModule,
        NzInputNumberModule,
        NzCheckboxModule,
        NzSelectModule,
        NzSwitchModule,
        NzMenuModule,
        NzDividerModule,
        NzPopoverModule,
        NzMessageModule,
        NzModalModule,
        NzSkeletonModule,
        NzFormModule,
        NzSpinModule,
        NzUploadModule,
        NzProgressModule,
        NzToolTipModule,
        NzPaginationModule,
        NzRadioModule,
        NzCollapseModule,
        NzTabsModule,
        NzResultModule,
        NzAlertModule,
        NzDropDownModule,
        NzDatePickerModule,
        NzAnchorModule,
        NzPipesModule,
    ],
    exports: [
        NzButtonModule,
        NzIconModule,
        NzTableModule,
        NzInputModule,
        NzInputNumberModule,
        NzSelectModule,
        NzSwitchModule,
        NzMenuModule,
        NzDividerModule,
        NzPopoverModule,
        NzMessageModule,
        NzCheckboxModule,
        NzModalModule,
        NzSkeletonModule,
        NzFormModule,
        NzSpinModule,
        NzUploadModule,
        NzProgressModule,
        NzToolTipModule,
        NzPaginationModule,
        NzRadioModule,
        NzCollapseModule,
        NzTabsModule,
        NzResultModule,
        NzAlertModule,
        NzDropDownModule,
        NzDatePickerModule,
        NzAnchorModule,
        NzPipesModule,
    ],
})
export class AntdModulesModule {}
